function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M500 623.8L159.9 963.9c-34.6 34.6-90.1 34.7-124.3.5-34.4-34.4-34-89.8.5-124.3L376.2 500 36.1 159.9C1.5 125.3 1.4 69.8 35.6 35.6c34.4-34.4 89.8-34 124.3.5L500 376.2 840.1 36.1c34.6-34.6 90.1-34.7 124.3-.5 34.4 34.4 34 89.8-.5 124.3L623.8 500l340.1 340.1c34.6 34.6 34.7 90.1.5 124.3-34.4 34.4-89.8 34-124.3-.5L500 623.8z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/error-icon.9d9404fc.svg";
export { SvgComponent as ReactComponent };